import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

/**
 * Aggregate, privacy-preserving visitor tracking.
 * - Fires POST /api/visit on every route change (SPA + first load).
 * - No cookies, no client-side identifiers — the server hashes IP+UA+daily-salt.
 * - Runs INDEPENDENTLY of PostHog consent (essential aggregate stats).
 * - Skips /admin routes so admin browsing doesn't inflate visitor numbers.
 */
export default function useVisitTracking() {
  const location = useLocation();
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (location.pathname.startsWith("/admin")) return;
    // Fire-and-forget; never block UI on tracking.
    api.post("/visit").catch(() => {});
  }, [location.pathname]);
}
